import { render, staticRenderFns } from "./postCompnent.vue?vue&type=template&id=4741aee4&scoped=true"
import script from "./postCompnent.vue?vue&type=script&lang=js"
export * from "./postCompnent.vue?vue&type=script&lang=js"
import style0 from "./postCompnent.vue?vue&type=style&index=0&id=4741aee4&prod&scoped=true&lang=css"
import style1 from "./postCompnent.vue?vue&type=style&index=1&id=4741aee4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4741aee4",
  null
  
)

export default component.exports